import React, { useEffect } from 'react';
import TickImg from '../assets/partner/tick.png';
import CustomLink from './CustomLink';
import PractitionerDe from '../assets/partner/practitioner-de.webp';
import useMeta from '../hooks/useMeta';
import { logo } from '../Data/Images/Home';

const PractitionersWebinarThankYou = () => {
  const { metaEvent } = useMeta();
  useEffect(() => {
    metaEvent('WebinarRegistration');
  }, []);

  return (
    <>
      <div className="sticky-top t-bg-secondary t-py-2">
        <div className="container">
          <img src={logo} alt="logo riise" width={60} />
        </div>
      </div>

      <div
        className="t-w-full t-max-w-[500px] t-mx-auto t-flex t-flex-col t-items-center t-justify-center t-gap-8 t-p-6"
        style={{ fontFamily: 'Roboto' }}
      >
        <div className="t-flex t-flex-col t-items-center t-justify-center t-gap-2">
          <h3 className="!t-m-0 t-font-extrabold">Danke für deine Anmeldung!</h3>
          <p className="!t-m-0 t-text-lg t-text-center">
            Du erhältst alle Informationen zur Teilnahme per E-Mail.
          </p>
          <p className="!t-m-0 t-text-lg t-text-center">
            Falls du Fragen hast, kannst du dich jederzeit an{' '}
            <span>
              <a href="mailto:hi@weriise.co" className="t-text-secondary">
                hi@weriise.co
              </a>
            </span>{' '}
            wenden.
          </p>
        </div>
        <div className="t-flex t-flex-col t-items-center t-justify-center t-gap-2">
          <h3 className="!t-m-0 t-font-extrabold t-text-center">Wann findet das Webinar statt?</h3>
          <p className="!t-m-0 t-text-lg t-text-center">Donnerstag, 18. Dezember 2025, 12:30 Uhr</p>
        </div>
        <div className="t-flex t-flex-col t-items-center t-justify-center t-gap-2">
          <h3 className="!t-m-0 t-font-extrabold">So nimmst du teil</h3>
          <p className="!t-m-0 t-text-lg t-text-center">
            Du kannst dir diesen Link speichern, um teilzunehmen:
          </p>
          <a
            href="https://event.webinarjam.com/93g3y2/live/llolr3cmi4inin"
            className="!t-m-0 t-text-lg t-text-center t-text-secondary !t-break-all"
            target="_blank"
            rel="noreferrer"
          >
            https://event.webinarjam.com/93g3y2/live/llolr3cmi4inin
          </a>
          <p className="!t-m-0 t-text-lg t-text-center">(wird dir auch per E-Mail zugeschickt)</p>
        </div>
        <div className="t-flex t-flex-col t-items-center t-justify-center t-gap-2">
          <h3 className="!t-m-0 t-font-extrabold">Plattform entdecken</h3>
          <p className="!t-m-0 t-text-lg t-text-center">
            In der Zwischenzeit kannst du bereits unsere neue Plattform für Ernährungsberater:innen &
            Gesundheitspraktiker:innen entdecken:
          </p>
          <div className="t-flex t-gap-2 t-mt-4">
            <img src={TickImg} alt="" className="t-h-6 t-w-12" />
            <p className="!t-m-0 t-text-lg">
              Erstelle vollständig personalisierte Rezepturen für deine Klient:innen
            </p>
          </div>
          <div className="t-flex t-gap-2">
            <img src={TickImg} alt="" className="t-h-6 t-w-12" />
            <p className="!t-m-0 t-text-lg">
              Verbessere die Einnahmetreue, indem du mehrere Kapseln durch 1 Beutel Mikrogranulate pro Tag
              ersetzt
            </p>
          </div>
          <div className="t-flex t-gap-2">
            <img src={TickImg} alt="" className="t-h-6 t-w-12" />
            <p className="!t-m-0 t-text-lg">Verdiene 20 % Provision – dauerhaft und ohne Aufwand</p>
          </div>
          <CustomLink to="/practitioners" className="btn btn-secondary !t-bg-secondary !t-rounded-lg t-mt-4">
            Zur Plattform
          </CustomLink>
        </div>
        <img src={PractitionerDe} alt="" className="img-fluid partner-img" />
      </div>
    </>
  );
};

export default PractitionersWebinarThankYou;
